import {
    getReservations,
    updateAuditstatus,
    updateVisitAuditstatus,
    updateRecognitionAuditstatus,
    updateNetsignAuditstatus,
    updateCommissionAuditstatus,
    addRecognition,
    addRefund,
    addNetSign,
    uploadNetSignMaterials,
    addCommission,
    getCustomerPhoneByRule,
    exportReservation,
} from "@/http/api/reservations";
import {
    getUsersSearch
} from "@/http/api/employe"
import {
    getOrgsSearch
} from "@/http/api/organization";
import {
    filterValType
} from "@/common/filters"
import {
    getEstates
} from "@/http/api/estate";

export default {
    data() {
        return {
            reservatStatus: "全部",
            waitingNum: null,
            reservationList: [],
            isLoading: true,
            isShowCopy: false,
            isShowReject: false,
            pageIndex: 1,
            noDataText: '无数据',
            totalCount: 0,
            searchText: "请输入客户姓名/客户手机号",
            isLoadingDownload: false,
            lastModificationTime: [],
            createDaterange: [],
            reservatInfo: {},
            permissions: this.$store.getters.permissions,
            recognitionInfo: {
                Number: "",
                More: "",
                Files: [],
            },
            netSignInfo: {
                netSignTime: "",
                price: 0,
                more: "",
                buildingNumber: null,
                unitNumber: null,
                houseNumber: null,
            },
            commissionInfo: {
                More: "",
                Files: [],
            },
            reason: "",
            searchTime: "报备日期",
            submitLoading: false,
            isShowAddRecognition: false,
            isShowRefund: false,
            isShowAddNetSign: false,
            isShowAddCommission: false,
            query: {
                brokerId: "",
                channelId: '',
                organizationUnitId: '',
                estateId: '',
                filter: "",
                condition: "",
                flowStatus: "",
                reviewStatus: "",
                creationEndTime: null,
                visitStartTime: null,
                visitEndTime: null,
                lastStartFlowTime: null,
                lastEndFlowTime: null,
                maxResultCount: 30,
                skipCount: 0,
                sorting: "creationTime desc",
                excludeReviewStatus: false,
            },
            netSignFiles: [],
            creatorlist: [],
            channellist: [],
            orgList: [],
            estates: [],
            statusOptions: [{
                label: '待审核',
                value: 'waiting',
            },
            {
                label: '已通过',
                value: 'success',
            },
            {
                label: '已驳回',
                value: 'refuse',
            }
            ]
        };
    },
    mounted() {
        this.getReservationList();
        this.getWaitingNum();
    },
    methods: {
        estateVisibleChange(v) {
            if (!v) {
                this.estates = [];
            }
        },
        getEstates(v) {
            if (v) {
                let query = {
                    filter: v,
                    condition: 'name',
                    maxResultCount: 30
                };
                this.noDataText = '加载中...';
                getEstates(query).then((res) => {
                    if (res && res.result) {
                        this.estates = res.result.items;
                    }
                    this.noDataText = '无数据';
                }).catch(() => {
                    this.noDataText = '无数据';
                })
            } else {
                this.estates = [];
            }
        },
        orgVisibleChange(v) {
            if (!v) {
                this.orgList = [];
            }
        },
        channelVisibleChange(v) {
            if (!v) {
                this.channellist = [];
            }
        },
        userVisibleChange(v) {
            if (!v) {
                this.creatorlist = [];
            }
        },
        getOrgsSearch(v) {
            this.orgList = [];
            let query = {
                filter: v,
                maxResultCount: 30
            };
            this.noDataText = '加载中...';
            getOrgsSearch(query).then((res) => {
                this.orgList = res.result.items;
                this.noDataText = '无数据';
            }).catch(() => {
                this.noDataText = '无数据';
            })
        },
        clearOrg() {
            this.orgList = [];
        },
        getOrgs(query) {
            if (query) {
                this.getOrgsSearch(query);
            } else {
                this.orgList = [];
            }
        },
        //获取经纪人
        getUsersSearch(e) {
            if (e) {
                var params = {
                    filter: e,
                    maxResultCount: 30,
                };
                let query = "";
                for (var key in params) {
                    if (params[key] !== null && params[key] !== "") {
                        query = `${key}=${params[key]}&${query}`;
                    }
                }
                this.noDataText = '加载中...';
                getUsersSearch(query).then(res => {
                    if (res.code == 10200) {
                        this.creatorlist = res.result.items
                    }
                    this.noDataText = '无数据';
                }).catch(() => {
                    this.noDataText = '无数据';
                })
            } else {
                this.creatorlist = [];
            }
        },
        getChannelSearch(e) {
            if (e) {
                var params = {
                    filter: e,
                    maxResultCount: 30,
                };
                let query = "";
                for (var key in params) {
                    if (params[key] !== null && params[key] !== "") {
                        query = `${key}=${params[key]}&${query}`;
                    }
                }
                this.noDataText = '加载中...';
                getUsersSearch(query).then((res) => {
                    if (res.code == 10200) {
                        this.channellist = res.result.items;
                    }
                    this.noDataText = '无数据';
                }).catch(() => {
                    this.noDataText = '无数据';
                })
            } else {
                this.channellist = [];
            }
        },
        //结佣
        commission(item) {
            if (this.permissions["Reservation.CommissionSubmit"]) {
                this.isShowAddCommission = !this.isShowAddCommission;
                if (item) {
                    this.reservatInfo = item;
                }
                this.commissionInfo = {
                    More: "",
                    Files: [],
                }
            } else {
                this.$message.warning({
                    message: `您暂无管理报备权限`,
                    showClose: true,
                });
            }
        },
        exportReservation() {
            this.isLoadingDownload = true

            let query = {
                brokerId: this.query.brokerId,
                channelId: this.query.channelId,
                organizationUnitId: this.query.organizationUnitId,
                estateId: this.query.estateId,
                filter: this.query.filter,
                condition: this.query.condition,
                flowStatus: this.query.flowStatus,
                reviewStatus: this.query.reviewStatus,
                creationStartTime: this.query.creationStartTime,
                creationEndTime: this.query.creationEndTime,
                visitStartTime: this.query.visitStartTime,
                visitEndTime: this.query.visitEndTime,
                lastStartFlowTime: this.query.lastStartFlowTime,
                lastEndFlowTime: this.query.lastEndFlowTime,
                maxResultCount: 30,
                skipCount: 0,
                isRefund: false,
                sorting: "creationTime desc",
                excludeReviewStatus: false,
            }
            if (this.reservatStatus == "waiting") {

                delete query.isRefund;
            } else if (this.reservatStatus == "reservation") {
                delete query.isRefund;
            } else if (this.reservatStatus == "全部") {
                delete query.isRefund;
            } else if (this.reservatStatus == "recognition" || this.reservatStatus == "netSign") {
                query.isRefund = false;
            } else {
                delete query.isRefund;
            }
            exportReservation(query).then((res) => {
                const content = res;
                const blob = new Blob([content]);
                if ("download" in document.createElement("a")) {
                    // 非IE下载
                    const elink = document.createElement("a");
                    elink.download = "报备列表.xlsx";
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, "报备列表.xlsx");
                }
                this.isLoadingDownload = false
            }).catch(err => {
                this.isLoadingDownload = false
            });
        },
        //添加结佣资料
        handleCommissionPreview(file) {
            if (this.commissionInfo.Files.length < 5) {
                this.commissionInfo.Files.push({
                    file: file.raw,
                    url: URL.createObjectURL(file.raw),
                    checked: false,
                    type: "",
                    error: false,
                });
            } else {
                this.$message({
                    message: "最多只允许上传5张图片",
                    showClose: true,
                });
            }
        },
        delCommissionPhotoItme(index) {
            this.commissionInfo.Files.splice(index, 1);
        },
        submitCommissionInfo() {
            let formData = new FormData();
            this.submitLoading = true;
            formData.append(`More`, this.commissionInfo.More);
            this.commissionInfo.Files.map((el, i) => {
                formData.append(`Files`, el.file);
            });
            addCommission(this.reservatInfo.id, formData)
                .then((res) => {
                    this.submitLoading = false;
                    if (res) {
                        this.$message.success({
                            message: res.message
                        });
                    }
                    this.commission();
                })
                .catch((err) => {
                    this.submitLoading = false;
                    this.$message({
                        message: err.message
                    });
                });
        },
        //网签
        netsign(item) {
            if (this.permissions["Reservation.NetSignSubmit"]) {
                this.isShowAddNetSign = !this.isShowAddNetSign;
                if (item) {
                    this.reservatInfo = item;
                }
                this.netSignInfo = {
                    netSignTime: "",
                    price: 0,
                    more: "",
                    buildingNumber: null,
                    unitNumber: null,
                    houseNumber: null,
                }
                this.netSignFiles = []
            } else {
                this.$message.warning({
                    message: `您暂无添加网签权限`,
                    showClose: true,
                });
            }
        },
        handleNetSignPreview(file) {
            if (this.netSignFiles.length < 5) {
                this.netSignFiles.push({
                    file: file.raw,
                    url: URL.createObjectURL(file.raw),
                    checked: false,
                    type: "",
                    error: false,
                });
            } else {
                this.$message({
                    message: "最多只允许上传5张图片",
                    showClose: true,
                });
            }
        },
        delNetSignPhotoItme(index) {
            this.netSignFiles.splice(index, 1);
        },
        submitNetSign() {
            this.submitLoading = true;
            addNetSign(this.reservatInfo.id, this.netSignInfo).then((res) => {
                this.submitLoading = false;
                if (res.result) {
                    let formData = new FormData();
                    this.netSignFiles.map((el, i) => {
                        formData.append(`materials[${i}].File`, el.file);
                        formData.append(`materials[${i}].Type`, el.file.type);
                    });
                    this.$message.success({
                        message: res.message,
                        showClose: true,
                    });
                    uploadNetSignMaterials(this.reservatInfo.id, res.result, formData).then(res => {
                        this.netsign()
                    });
                }
            });
        },
        //退订
        refund(item) {
            if (this.permissions["Reservation.RefundManage"]) {
                this.isShowRefund = !this.isShowRefund;
                this.reason = ""
                if (item) {
                    this.reservatInfo = item;
                }
            } else {
                this.$message.warning({
                    message: `您暂无退订权限`,
                    showClose: true,
                });
            }
        },
        submitRefund() {
            let data = {
                more: this.reason,
            };
            this.submitLoading = true;
            addRefund(this.reservatInfo.id, data)
                .then((res) => {
                    if (res) {
                        this.$message.success({
                            message: res.message
                        });
                    }
                    this.submitLoading = false;
                    this.isShowRefund = false;
                    this.getReservationList();
                })
                .catch((err) => {
                    this.submitLoading = false;
                    this.$message({
                        message: err.message
                    });
                });
        },
        //添加认筹/购
        handlePictureCardPreview(file) {
            if (this.recognitionInfo.Files.length < 5) {
                this.recognitionInfo.Files.push({
                    file: file.raw,
                    url: URL.createObjectURL(file.raw),
                    checked: false,
                    type: "",
                    error: false,
                });
            } else {
                this.$message({
                    message: "最多只允许上传5张图片",
                    showClose: true,
                });
            }
        },
        // 删除相册
        delPhotoItme(index) {
            this.recognitionInfo.Files.splice(index, 1);
        },
        submitRecognitionInfo() {
            if (this.permissions["Reservation.RecognitionSubmit"]) {

                let formData = new FormData();
                this.submitLoading = true;
                if (this.recognitionInfo.Number) {
                    formData.append(`Number`, this.recognitionInfo.Number);
                }
                if (this.recognitionInfo.More) {
                    formData.append(`More`, this.recognitionInfo.More);
                }
                this.recognitionInfo.Files.map((el, i) => {
                    formData.append(`Files`, el.file);
                });
                addRecognition(this.reservatInfo.id, formData)
                    .then((res) => {
                        this.submitLoading = false;
                        if (res) {
                            this.$message.success({
                                message: res.message
                            });
                        }
                        this.showAddRecognition();
                    })
                    .catch((err) => {
                        this.submitLoading = false;
                        this.$message({
                            message: err.message
                        });
                    });
            } else {
                this.$message.warning({
                    message: `您暂无认购权限`,
                    showClose: true,
                });
            }

        },
        showAddRecognition(item) {
            this.isShowAddRecognition = !this.isShowAddRecognition;
            if (item) {
                this.reservatInfo = item;
            }
            this.recognitionInfo = {
                Number: "",
                More: "",
                Files: [],
            }
        },
        toEstate(id) {
            this.$router.push({
                path: `/estate/detail/${id}`
            });
        },
        toCustomer(id) {
            this.$router.push({
                path: `/customer/detail/${id}`
            });
        },
        toVisit(item) {
            if (this.permissions["Reservation.VisitSubmit"]) {
                this.$router.push({
                    path: `/reservation/visit/${item.id}`
                });
            } else {
                this.$message.warning({
                    message: `您暂无录入带看权限`,
                    showClose: true,
                });
            }
        },
        showReject() {
            this.isShowReject = !this.isShowReject;
        },

        submitReject() {
            this.updateAuditstatus(false);
        },
        edit(item, val) {
            let path = val ? `/reservation/detail/${item.id}?type=${val}` : `/reservation/detail/${item.id}`;
            this.$router.push({
                path
            });
        },
        updateStatus(item, status) {
            let permission = ""
            if (item.flowStatus == '报备') {
                permission = "Reservation.Review"
            } else if (item.flowStatus == '带看') {
                permission = "Reservation.VisitReview"
            } else if (item.flowStatus == '认购') {
                permission = "Reservation.RecognitionManage"
            } else if (item.flowStatus == '签约') {
                permission = "Reservation.NetSignReview"
            } else if (item.flowStatus == '结佣') {
                permission = "Reservation.CommissionReview"
            }
            if (this.permissions[permission]) {
                this.reservatInfo = item;
                if (status) {
                    this.$confirm(`是否确定通过？`, `温馨提示`, {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                    })
                        .then(() => {
                            this.updateAuditstatus(true);
                        })
                        .catch(() => { });
                } else {
                    this.reason = ""
                    this.showReject();
                }
            } else {
                this.$message.warning({
                    message: `您暂无管理该报备权限`,
                    showClose: true,
                });
            }
        },
        updateAuditstatus(status) {
            this.subLoading = true;
            let val = {
                isValidity: status,
                refusedReason: this.reason,
            };
            if (this.reservatInfo.flowStatus == '报备') {
                updateAuditstatus(this.reservatInfo.id, val)
                    .then((res) => {
                        if (res.code == 10200) {
                            this.$message.success({
                                message: res.message
                            });
                            this.isShowReject = false;
                            this.getReservationList();
                        }
                    })
                    .catch((err) => {
                        this.subLoading = false;
                    });
            } else if (this.reservatInfo.flowStatus == '带看') {
                updateVisitAuditstatus(this.reservatInfo.id, val)
                    .then((res) => {
                        if (res.code == 10200) {
                            this.$message.success({
                                message: res.message
                            });
                            this.isShowReject = false;
                            this.getReservationList();
                        }
                    })
                    .catch((err) => {
                        this.subLoading = false;
                    });
            } else if (this.reservatInfo.flowStatus == '认购') {
                updateRecognitionAuditstatus(this.reservatInfo.id, val)
                    .then((res) => {
                        if (res.code == 10200) {
                            this.$message.success({
                                message: res.message
                            });
                            this.isShowReject = false;
                            this.getReservationList();
                        }
                    })
                    .catch((err) => {
                        this.subLoading = false;
                    });
            } else if (this.reservatInfo.flowStatus == '签约') {
                updateNetsignAuditstatus(this.reservatInfo.id, val)
                    .then((res) => {
                        if (res.code == 10200) {
                            this.$message.success({
                                message: res.message
                            });
                            this.isShowReject = false;
                            this.getReservationList();
                        }
                    })
                    .catch((err) => {
                        this.subLoading = false;
                    });
            } else if (this.reservatInfo.flowStatus == '结佣') {
                updateCommissionAuditstatus(this.reservatInfo.id, val)
                    .then((res) => {
                        if (res.code == 10200) {
                            this.$message.success({
                                message: res.message
                            });
                            this.isShowReject = false;
                            this.getReservationList();
                        }
                    })
                    .catch((err) => {
                        this.subLoading = false;
                    });
            }

        },
        copyClose() {
            this.isShowCopy = false;
        },
        showCopy(item) {
            getCustomerPhoneByRule(item.id).then(res => {
                this.reservatInfo = item;
                this.reservatInfo.customerPhoneNumber = res.result.customerPhone;
                this.isShowCopy = true;
            })
        },
        copy() {
            var Url = document.getElementById("content").innerHTML;
            const input = document.createElement("textarea");
            input.value = Url;
            document.body.appendChild(input);
            input.select();
            document.execCommand("Copy");
            document.body.removeChild(input);
            this.isShowCopy = false;
            this.$message.success({
                message: "复制成功"
            });
        },
        toCreateReservat() {
            if (this.permissions["Reservation.Create"]) {
                this.$router.push({
                    path: `/reservation/create`
                });
            } else {
                this.$message.warning({
                    message: `您暂无报备权限`,
                    showClose: true,
                });
            }
        },
        deleteFilter() {
            this.query.brokerId = "";
            this.query.channelId = '';
            this.query.estateId = '';
            this.query.organizationUnitId = '';
            this.query.flowStatus = "";
            this.query.reviewStatus = "";
            this.query.creationStartTime = null;
            this.query.creationEndTime = null;
            this.query.visitStartTime = null;
            this.query.visitEndTime = null;
            this.query.lastStartFlowTime = null;
            this.query.lastEndFlowTime = null;
            this.query.filter = "";
            this.query.condition = "";
            this.lastModificationTime = [];
            this.createDaterange = [];
            this.query.excludeReviewStatus = false
            this.getReservationList();
            // this.$nextTick(() => {
            //     //在数据加载完，重新渲染表格,防止抖动
            //     this.$nextTick(() => {
            //       this.$refs["reservationTable"].doLayout();
            //     });
            // });
        },
        // 搜索前置条件
        filterSelect(val) {
            if (val == "请输入客户手机号") {
                this.query.condition = "creatorPhoneNumber";
            } else if (val == "请输入客户姓名") {
                this.query.condition = "customerName";
            } else {
                this.query.condition = "";
            }
        },
        enterSearch() {
            var evt = window.event || e;
            if (evt.keyCode == 13) {
                // 回车事件
                this.getReservationList();
            }
        },
        // 更改的页面数量
        handleSizeChange(val) {
            this.query.maxResultCount = val;
            this.getReservationList()
        },
        // 跳转的指定页
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getReservationList()
        },
        changeStudent(v) {
            this.pageIndex = 1;
            let name = v.name;
            switch (name) {
                case '全部':
                    this.searchTime = '报备时间'
                    break;
                case 'waiting':
                    this.searchTime = '报备时间'
                    break;
                case 'reservation':
                    this.searchTime = '报备时间'
                    break;
                case 'visit':
                    this.searchTime = '带看时间'
                    break;
                case 'recognition':
                    this.searchTime = '认购时间'
                    break;
                case 'netSign':
                    this.searchTime = '签约时间'
                    break;
            }
            this.deleteFilter();
        },
        getReservationList() {
            console.log(this.reservatStatus, 'reservatStatus');
            if (this.lastModificationTime && this.lastModificationTime.length) {
                this.query.lastStartFlowTime = this.lastModificationTime[0];
                this.query.lastEndFlowTime = this.lastModificationTime[1];
            } else {
                this.query.lastStartFlowTime = '';
                this.query.lastEndFlowTime = '';
            }
            if (this.createDaterange && this.createDaterange.length) {
                this.query.creationStartTime = this.createDaterange[0];
                this.query.creationEndTime = this.createDaterange[1];
            } else {
                this.query.creationStartTime = null;
                this.query.creationEndTime = null;
            }
            if (this.reservatStatus == "waiting") {
                this.query.reviewStatus = this.reservatStatus;
                this.query.flowStatus = "";
                this.query.excludeReviewStatus = false;
                delete this.query.isRefund;
            } else if (this.reservatStatus == "reservation") {
                this.query.flowStatus = this.reservatStatus;
                this.query.excludeReviewStatus = false;
                delete this.query.isRefund;
            } else if (this.reservatStatus == "全部") {
                this.searchTime = '报备时间';
                this.query.flowStatus = '';
                this.query.excludeReviewStatus = false;
                delete this.query.isRefund;
            } else if (this.reservatStatus == "recognition" || this.reservatStatus == "netSign") {
                this.query.flowStatus = this.reservatStatus;
                this.query.excludeReviewStatus = false;
                this.query.isRefund = false;
            } else {
                this.query.flowStatus = this.reservatStatus;
                this.query.excludeReviewStatus = false;
                delete this.query.isRefund;
            }
            if (this.query.flowStatus == 'visit' || this.query.flowStatus == "recognition" || this.query.flowStatus == "netSign") {
                this.query.sorting = 'lastFlowTime desc';
            } else {
                this.query.sorting = 'creationTime desc';
            }
            this.isLoading = true;
            this.reservationList = []
            this.query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;
            getReservations(this.query)
                .then((res) => {
                    this.reservationList = res.result.items;
                    this.totalCount = res.result.totalCount;
                    this.isLoading = false;
                    if (this.reservatStatus == "waiting") {
                        this.waitingNum = res.result.totalCount ? res.result.totalCount : "";
                    }
                })
                .catch((err) => {
                    this.isLoading = false;
                });
        },
        getWaitingNum() {
            let query = {
                reviewStatus: 'waiting'
            };
            getReservations(query)
                .then((res) => {
                    this.waitingNum = res.result.totalCount ? res.result.totalCount : "";
                })
        }
    },
};